// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useMemo, useState } from "react";
import { Stack, useMediaQuery, useTheme, Box, Button } from "@mui/material";
import { default as dayjs } from "dayjs";
import {
  GridColDef,
  GridActionsCellItem,
  GridRenderCellParams,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { DeleteConfirmModal, Table } from "../../molecules";
import { Loading, StatusBar, StatusBarUser } from "../../atoms";
import {
  useAuthorization,
  useGetMerchantStatusList,
  useGetTaxRates,
  useDeleteTaxRate,
  TaxRate
} from "../../../hooks";
import { useNavigate, useLocation } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { PagingResponse } from "../../../hooks/_types";
import { downloadExcel } from "../../../util/downloadExcel";
import { createStatusOperator } from "../../molecules/StatusFilterComponents";
import { useUserInfo } from "../../../store/User.state";


function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;
  return <>{value && <StatusBarUser status={value} />}</>;
}

function RenderCurrency(props: GridRenderCellParams<any, string>) {
  const { value } = props;

  const renderMoney = (money: string) => {
    switch (money) {
      case "949":
        return "TL";
      case "840":
        return "USD";
      case "978":
        return "EUR";
      default:
        return "-";
    }
  };

  return <>{renderMoney(value)}</>;
}

export const TaxRatesList = () => {
  const theme = useTheme();
  const [userInfo] = useUserInfo();
  const { showAdd, showDelete, showUpdate } = useAuthorization();
  const location = useLocation();

  console.log("Authorization permissions:", { showAdd, showDelete, showUpdate });

  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const [tableData, setTableData] = useState<PagingResponse<Array<TaxRate>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const navigate = useNavigate();
  const { data: taxRatesData, isLoading, refetch } = useGetTaxRates();
  const { mutate: deleteTaxRate, isLoading: isDeleteLoading } = useDeleteTaxRate();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const setSnackbar = useSetSnackBar();
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  const { data: rawMerchantStatus, isLoading: isMerchantStatusLoading } =
    useGetMerchantStatusList({});

  useEffect(() => {
    const savedFilter = localStorage.getItem("TaxRatesFilter");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);

  useEffect(() => {
    if (location.state?.refresh) {
      setShouldRefresh(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state?.refresh, navigate, location.pathname]);


  const merchantStatuses = useMemo(() => {
    return rawMerchantStatus?.data?.map(
      (merchantStat: { value: string; key: number }) => {
        return {
          label: merchantStat?.key,
          value: `${merchantStat?.value}`,
        };
      }
    );
  }, [rawMerchantStatus?.data]);

  useEffect(() => {
    if (taxRatesData) {
      setTableData(taxRatesData?.data);
      if (taxRatesData?.isSuccess) {
        setSnackbar({
          severity: "success",
          isOpen: true,
          description: taxRatesData.message,
        });
      } else {
        setSnackbar({
          severity: "error",
          description: taxRatesData?.message,
          isOpen: true,
        });
      }
    }
  }, [taxRatesData, setSnackbar]);

  useEffect(() => {
    if (shouldRefresh) {
      refetch();
      setShouldRefresh(false);
    }
  }, [shouldRefresh, refetch]);


  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    refetch();
  };

  const editRow = React.useCallback(
    (taxRate: TaxRate) => () => {
      navigate("/edit-tax-rate", { state: { taxRateId: taxRate.id } });
    },
    [navigate]
  );

  const deleteRow = React.useCallback(
    (taxRate: TaxRate) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(taxRate.id));
    },
    []
  );

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    if (!selectedRowId) {
      setSnackbar({
        severity: "error",
        isOpen: true,
        description: "Silinecek vergi oranı seçilmemiş",
      });
      return;
    }

    deleteTaxRate(
      { id: selectedRowId },
      {
        onSuccess: (data: any) => {
          if (data?.isSuccess) {
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message || "Vergi oranı başarıyla silindi",
            });
            refetch();
          } else {
            setSnackbar({
              severity: "error",
              description: data?.message || "Silme sırasında hata oluştu",
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "Silme sırasında hata oluştu",
            isOpen: true,
          });
        },
      }
    );
    handleCloseDeleteModal();
  };
  const columns: GridColDef<TaxRate, any, any>[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => {
          if (params.row.status === 'PASSIVE' || params.row.merchantId === 0) {
            return [];
          }

          let actions = [];

          if (showUpdate) {
            actions.push(
              <GridActionsCellItem
                label="Düzenle"
                onClick={editRow(params.row)}
                showInMenu
              />
            );
          }

          if (showDelete) {
            actions.push(
              <GridActionsCellItem
                label="Sil"
                onClick={deleteRow(params.row)}
                showInMenu
              />
            );
          }

          return actions;
        },

      },
      { field: "id", headerName: "ID", width: 100 },
      { field: "name", headerName: "Vergi Oranı Adı", width: 250 },
      { field: "tax", headerName: " Vergi Oranı (%)", width: 130 },
    ];
  }, [deleteRow, editRow, showDelete, showUpdate, merchantStatuses]);
  const keyMapping = {
    status: "Durum",
  };
  const onSave = () => {
    if (taxRatesData && taxRatesData.isSuccess) {
      function fieldValue(data) {
        return data?.map((item) => {
          return {
            "ID": item?.id,
            "Vergi Oranı Adı": item?.name,
            "Oran (%)": item?.tax,
          };
        });
      }
      const refactoredData = fieldValue(taxRatesData?.data?.result);
      downloadExcel(refactoredData || [], "Vergi Oranları Listesi", keyMapping);
    } else {
      setSnackbar({
        severity: "error",
        description: "Veri bulunamadı",
        isOpen: true,
      });
    }
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      localStorage.removeItem("TaxRatesFilter");
      return setQueryOptions({});
    }
    const queryParams = getQueryParams(filters);
    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
      localStorage.setItem("TaxRatesFilter", JSON.stringify(queryParams));
    }

    previousQueryParams.current = queryParams;

  }, 500);

  const previousQueryParams = React.useRef({});

  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;


  const hasLoading = isLoading || isDeleteLoading;

  const handleAddProductGroup = () => {
    navigate("/add-tax-rate");
  };

  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} p={2}>
        <>
          {showAdd && (
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                onClick={handleAddProductGroup}
                sx={{ mr: 1 }}
              >
                Yeni Vergi Oranı Ekle
              </Button>
            </Box>
          )}
          <Table
            filterKey="TaxRatesFilter"
            columnVisibilityConfigKey="TaxRatesColumnVisibilityKey"
            hasActiveFilters={hasActiveFilters}
            handleFilterChange={handleFilterChange}
            paginationModel={paginationModel}
            onPaginationModelChange={handleChangePagination}
            paginationMode="server"
            rowCount={tableData?.totalItems || 0}
            sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
            isRowSelectable={() => false}
            // disableColumnMenu
            rows={tableData?.result || []}
            columns={columns}
            getRowClassName={(params) => {
              if (params.row.status === "PASSIVE") return "blocked-row";
              if (params.row.status === "BLOCKED") return "pasive-row";
              return "";
            }}
            exportFileName="Vergi Oranları Listesi"
            onSave={() => onSave()}
          />
          <DeleteConfirmModal
            isOpen={isDeleteModalOpen}
            onClose={handleCloseDeleteModal}
            onConfirm={() => handleDeleteConfirm()}
          ></DeleteConfirmModal>
        </>

      </Stack>
    </>
  );
};
